import styled from 'styled-components';

import { IFeature, IGlassesPackage } from '../../types';
import { PackageNameDisplay } from './PackageNameDisplay';
import { PackagePriceDisplay } from './PackagePriceDisplay';
import { FeatureList } from '../FeatureList';

import { breakpoints, spacing } from '../../constants';
import { displayPrice } from '../../utils';

const HeaderRow = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding-bottom: ${spacing.lg};
    margin-bottom: 20px;
    margin-top: 60px;

    @media (${breakpoints.mediumMin}) {
        flex-direction: row;
        padding-right: 40px;
        align-items: center;
        padding-bottom: 0;
        margin-top: 0;
    }
`;

interface IProps {
    className?: string;
    allFeatures: IFeature[];
    selectedPackage: IGlassesPackage;
}

const BaseGlassesPackageDisplay = ({
    allFeatures,
    selectedPackage,
    className,
}: IProps) => (
    <div className={className}>
        <HeaderRow>
            <PackageNameDisplay packageName={selectedPackage.name} />
            <PackagePriceDisplay textColor={selectedPackage.textColorGeneral}>
                {displayPrice(selectedPackage.priceInt)}
            </PackagePriceDisplay>
        </HeaderRow>
        <FeatureList
            allFeatures={allFeatures}
            glassesPackage={selectedPackage}
        />
    </div>
);

export const GlassesPackageDisplay = styled(BaseGlassesPackageDisplay)`
    @media (${breakpoints.mediumMin}) {
        flex: 0 0 45%;
    }
`;
